import React, { memo } from 'react';

import Fonts from '@/assets/fonts/families/index.ts';
import withExposer from '@/hocs/with-exposer';
import useLoadFonts from '@/hooks/use-load-fonts';
import { Global, css } from '@emotion/react';

const FontComponent: React.FC = () => {
	const fontsCss = useLoadFonts(Fonts);

	if (!fontsCss.length) return null;

	return (
		<Global
			styles={css`
				${fontsCss.join('')}
			`}
		/>
	);
};

const Font = memo(withExposer(FontComponent, 'font'));

export default Font;
